import { render, staticRenderFns } from "./SummerFestivalInventory.vue?vue&type=template&id=5bd11167"
import script from "./SummerFestivalInventory.vue?vue&type=script&lang=js"
export * from "./SummerFestivalInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports